var _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetailSector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 28,
    r: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 28,
    r: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m28 7h-22.18l-.82-4.2a1 1 0 0 0 -1-.8h-4v2h3.18l3.82 19.2a1 1 0 0 0 1 .8h18v-2h-17.18l-.82-4h18a1 1 0 0 0 1-.78l2-9a1 1 0 0 0 -1-1.22zm-2.8 9h-17.58l-1.4-7h20.53z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h32v32h-32z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetailSector);
export default __webpack_public_path__ + "static/media/Retail Sector.379dc737c0b458ea774bd17b7822dde4.svg";
export { ForwardRef as ReactComponent };